import React from "react";

const Features = ({ featuresRef }) => {
  return (
    <div ref={featuresRef}>
      <section id="tabs" className="tabs ">
        <div className="container text-justify" data-aos="fade-up">
          <div className="section-header">
            <h2>Features</h2>
            <p>
              Empowering Connections, Enriching Experiences: Your Gateway to
              Seamless, Interactive, and Global Conferences!
            </p>
          </div>
          <ul className="nav nav-tabs row d-flex">
            <li className="nav-item col-3">
              <a
                className="nav-link active show"
                data-bs-toggle="tab"
                data-bs-target="#tab-1"
              >
                <i className="bi bi-card-checklist"></i>
                <h4 className="d-none d-lg-block">
                  Interactive Agenda Builder
                </h4>
              </a>
            </li>
            <li className="nav-item col-3">
              <a
                className="nav-link"
                data-bs-toggle="tab"
                data-bs-target="#tab-2"
              >
                <i className="bi bi-card-checklist"></i>
                <h4 className="d-none d-lg-block">
                  Live Streaming and On-Demand Access
                </h4>
              </a>
            </li>
            <li className="nav-item col-3">
              <a
                className="nav-link"
                data-bs-toggle="tab"
                data-bs-target="#tab-3"
              >
                <i className="bi bi-card-checklist"></i>
                <h4 className="d-none d-lg-block">Virtual Exhibition Hall</h4>
              </a>
            </li>
            <li className="nav-item col-3">
              <a
                className="nav-link"
                data-bs-toggle="tab"
                data-bs-target="#tab-4"
              >
                <i className="bi bi-card-checklist"></i>
                <h4 className="d-none d-lg-block">
                  Collaborative Research Hub
                </h4>
              </a>
            </li>
          </ul>

          <div className="tab-content">
            <div className="tab-pane active show" id="tab-1">
              <div className="row">
                <div
                  className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <h3>
                    Elevate Your Conference Experience with the Interactive
                    Agenda Builder.
                  </h3>
                  <p className="fst-italic">
                    The Interactive Agenda Builder is a sophisticated and
                    empowering feature meticulously crafted to enhance the
                    conference experience for all attendees. This intuitive tool
                    is designed to provide participants with a personalized and
                    seamless scheduling journey, allowing them to curate their
                    conference itinerary with precision. Through an easy-to-use
                    interface, attendees can navigate the diverse array of
                    sessions, workshops, and activities, tailoring their
                    schedules to align with their individual interests and
                    professional objectives.
                  </p>
                  <ul>
                    <li>
                      <i className="ri-check-double-line"></i> This feature goes
                      beyond mere scheduling; it serves as a dynamic tool for
                      attendees to take ownership of their conference journey.
                      With the Interactive Agenda Builder, participants can
                      prioritize and select sessions that matter most to them,
                      ensuring a highly personalized and efficient use of their
                      time throughout the event.
                    </li>
                    <li>
                      <i className="ri-check-double-line"></i> This level of
                      customization not only fosters individual engagement but
                      also contributes to an overall sense of satisfaction and
                      fulfillment.
                    </li>
                    <li>
                      <i className="ri-check-double-line"></i> Your conference
                      becomes a truly tailored experience, setting the stage for
                      success and meaningful participation for every attendee.
                      The Interactive Agenda Builder is more than just a
                      scheduling tool; it's a key component in creating a
                      vibrant and dynamic conference environment that resonates
                      with the diverse needs of your audience. Elevate your
                      conference experience with precision and personalization –
                      it's the future of seamless event engagement.
                    </li>
                  </ul>
                  <p></p>
                </div>
                <div
                  className="col-lg-6 order-1 order-lg-2 text-center"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <img
                    src="assests/Images/tabs-1.jpg"
                    alt=""
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
            <div className="tab-pane" id="tab-2">
              <div className="row">
                <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0">
                  <h3>
                    Transform Your Conference with Live Streaming and On-Demand
                    Access
                  </h3>
                  <p>
                    Elevate your conference experience with our Live Streaming
                    and On-Demand Access feature. This powerful tool allows
                    participants to engage with key sessions in real-time
                    through live streaming and provides the flexibility to
                    access recorded content at their convenience.
                  </p>
                  <p className="fst-italic">
                    Enhance your conference experience with real-time engagement
                    and flexible access to recorded sessions.
                  </p>
                  <ul>
                    <li>
                      <i className="ri-check-double-line"></i> Participants can
                      join important sessions remotely, ensuring a global and
                      inclusive reach for your conference.
                    </li>
                    <li>
                      <i className="ri-check-double-line"></i> Missed a session?
                      No problem. Our On-Demand Access feature allows attendees
                      to catch up on recorded content at their own pace,
                      providing a flexible and convenient conference experience.
                    </li>
                    <li>
                      <i className="ri-check-double-line"></i> This feature not
                      only extends the accessibility of your conference but also
                      caters to diverse schedules and time zones, accommodating
                      participants from around the world.
                    </li>
                    <li>
                      <i className="ri-check-double-line"></i> Uplift your
                      conference engagement by offering a dynamic and inclusive
                      platform that seamlessly integrates live streaming and
                      on-demand accessibility.
                    </li>
                  </ul>
                </div>
                <div className="col-lg-6 order-1 order-lg-2 text-center">
                  <img
                    src="assests/Images/tabs-2.jpg"
                    alt=""
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
            <div className="tab-pane" id="tab-3">
              <div className="row">
                <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0">
                  <h3>
                    Explore a world of possibilities in our Virtual Exhibition
                    Hall feature.
                  </h3>
                  <p>
                    Experience the convenience of browsing through exhibitor
                    booths from the comfort of your own space, creating a
                    seamless and accessible conference environment. Immerse
                    yourself in a dynamic space where sponsors and exhibitors
                    showcase their products and services. Elevate your
                    conference experience by engaging with virtual booths,
                    interacting with representatives, and accessing exclusive
                    promotional materials.
                  </p>
                  <ul>
                    <li>
                      <i className="ri-check-double-line"></i> Connect directly
                      with sponsors and exhibitors through interactive features,
                      fostering meaningful collaborations and partnerships.
                    </li>
                    <li>
                      <i className="ri-check-double-line"></i> Access exclusive
                      content, product demonstrations, and promotional materials
                      to enhance your understanding of the latest innovations
                      and offerings.
                    </li>
                    <li>
                      <i className="ri-check-double-line"></i> Elevate your
                      conference engagement by stepping into the future of
                      virtual exhibitions.
                    </li>
                  </ul>
                  <p className="fst-italic">
                    Discover a virtual space that transcends physical
                    boundaries, providing an immersive experience for exhibitors
                    and attendees alike.
                  </p>
                </div>
                <div className="col-lg-6 order-1 order-lg-2 text-center">
                  <img
                    src="assests/Images/tabs-3.jpg"
                    alt=""
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
            <div className="tab-pane" id="tab-4">
              <div className="row">
                <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0">
                  <h3>
                    Foster Collaboration in the Collaborative Research Hub
                  </h3>
                  <p>
                    Embrace a collaborative research culture with our dedicated
                    Collaborative Research Hub feature. This space is
                    meticulously designed to facilitate knowledge exchange,
                    discussions, and connections among conference participants.
                    Uplift your conference experience by creating a central hub
                    for authors, researchers, and attendees to engage beyond
                    scheduled sessions.
                  </p>
                  <p className="fst-italic">
                    Encourage ongoing discussions and collaboration among
                    authors and researchers, fostering a sense of community and
                    shared knowledge.
                  </p>
                  <ul>
                    <li>
                      <i className="ri-check-double-line"></i> Provide a
                      platform for attendees to share additional resources,
                      insights, and updates, enhancing the overall depth of the
                      conference content.
                    </li>
                    <li>
                      <i className="ri-check-double-line"></i> Seamlessly
                      integrate the Collaborative Research Hub with the
                      conference management system, ensuring a fluid transition
                      from submission to an ongoing scholarly discourse.
                    </li>
                    <li>
                      <i className="ri-check-double-line"></i> Elevate your
                      conference beyond traditional boundaries with a dedicated
                      Collaborative Research Hub that encourages continuous
                      collaboration and knowledge sharing.
                    </li>
                  </ul>
                </div>
                <div className="col-lg-6 order-1 order-lg-2 text-center">
                  <img
                    src="assests/Images/tabs-4.jpg"
                    alt=""
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Features;
